import { cn } from '@ifixit/ui/lib/utils';
import { EditorVersionLink, type EditorVersionLinkProps } from './editor_version_link';
import { LicenseDisclaimer } from './license_disclaimer';
import type { ReactNode } from 'react';

/**
 * The quiet strip every editor ends with: the licensing footnote (where
 * shown) on the left, the editor version link and any page-specific quiet
 * controls (e.g. the keyboard-shortcuts entry) on the right. One shared
 * slot so the version link sits in the same place on every editor surface
 * — v1's counterpart is Guide/UI/templates/editor_footer.phtml.
 */
export function EditorFooter({
   editorVersionLink,
   showLicenseDisclaimer = false,
   className,
   children,
}: {
   editorVersionLink?: EditorVersionLinkProps | null;
   showLicenseDisclaimer?: boolean;
   className?: string;
   children?: ReactNode;
}) {
   return (
      <div
         className={cn(
            'mt-6 flex flex-wrap items-baseline justify-between gap-x-4 gap-y-1',
            className
         )}
      >
         {showLicenseDisclaimer ? <LicenseDisclaimer className="m-0" /> : <span />}
         <span className="flex items-center gap-4">
            <EditorVersionLink link={editorVersionLink} />
            {children}
         </span>
      </div>
   );
}
